import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Cookie, X, Check, Settings } from 'lucide-react';

function CookieBanner() {
    const [visible, setVisible] = useState(false);
    const [showDetails, setShowDetails] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem('cookieConsent');
        if (!consent) setVisible(true);
    }, []);

    const acceptAll = () => {
        localStorage.setItem('cookieConsent', 'accepted');
        setVisible(false);
    };

    const acceptNecessary = () => {
        localStorage.setItem('cookieConsent', 'necessary');
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div className="fixed bottom-0 left-0 right-0 z-[100] p-4 md:p-6">
            <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-2xl border border-gray-100 overflow-hidden">
                <div className="p-5 md:p-6">
                    <div className="flex items-start gap-4">
                        <div className="flex-shrink-0 w-10 h-10 bg-orange-100 rounded-full flex items-center justify-center">
                            <Cookie className="w-5 h-5 text-orange-500" />
                        </div>
                        <div className="flex-1 min-w-0">
                            <h3 className="text-base font-semibold text-gray-900 mb-1">
                                Diese Website verwendet Cookies
                            </h3>
                            <p className="text-sm text-gray-600 leading-relaxed">
                                Wir verwenden technisch notwendige Cookies für den Login und die Session-Verwaltung.
                                Weitere Tracking- oder Analyse-Cookies setzen wir nicht ein.
                                Mehr Infos in unserer{' '}
                                <Link to="/datenschutz" className="text-orange-500 hover:underline font-medium">
                                    Datenschutzerklärung
                                </Link>.
                            </p>

                            {showDetails && (
                                <div className="mt-3 rounded-lg border border-gray-200 overflow-hidden text-xs">
                                    <table className="w-full">
                                        <thead>
                                            <tr className="bg-gray-50 text-gray-600">
                                                <th className="text-left p-2 font-medium">Name</th>
                                                <th className="text-left p-2 font-medium">Zweck</th>
                                                <th className="text-left p-2 font-medium">Speicherort</th>
                                                <th className="text-left p-2 font-medium">Laufzeit</th>
                                            </tr>
                                        </thead>
                                        <tbody className="divide-y divide-gray-100">
                                            <tr>
                                                <td className="p-2 font-mono text-gray-700">PHPSESSID</td>
                                                <td className="p-2 text-gray-600">Login-Session</td>
                                                <td className="p-2 text-gray-600">Cookie</td>
                                                <td className="p-2 text-gray-600">Sitzung</td>
                                            </tr>
                                            <tr className="bg-gray-50">
                                                <td className="p-2 font-mono text-gray-700">user</td>
                                                <td className="p-2 text-gray-600">Nutzerdaten</td>
                                                <td className="p-2 text-gray-600">localStorage</td>
                                                <td className="p-2 text-gray-600">Bis Abmelden</td>
                                            </tr>
                                            <tr>
                                                <td className="p-2 font-mono text-gray-700">cookieConsent</td>
                                                <td className="p-2 text-gray-600">Einwilligung</td>
                                                <td className="p-2 text-gray-600">localStorage</td>
                                                <td className="p-2 text-gray-600">1 Jahr</td>
                                            </tr>
                                            <tr className="bg-gray-50">
                                                <td className="p-2 font-mono text-gray-700">lastActivity</td>
                                                <td className="p-2 text-gray-600">Session-Timeout</td>
                                                <td className="p-2 text-gray-600">localStorage</td>
                                                <td className="p-2 text-gray-600">Bis Abmelden</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="flex flex-wrap items-center justify-between gap-3 mt-4">
                        <button
                            onClick={() => setShowDetails(v => !v)}
                            className="flex items-center gap-1.5 text-sm text-gray-500 hover:text-gray-700 transition-colors"
                        >
                            <Settings className="w-4 h-4" />
                            {showDetails ? 'Details ausblenden' : 'Details anzeigen'}
                        </button>

                        <div className="flex items-center gap-2 flex-wrap">
                            <button
                                onClick={acceptNecessary}
                                className="flex items-center gap-1.5 px-4 py-2 text-sm text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
                            >
                                <X className="w-4 h-4" />
                                Nur notwendige
                            </button>
                            <button
                                onClick={acceptAll}
                                className="flex items-center gap-1.5 px-5 py-2 text-sm font-medium text-white bg-orange-500 hover:bg-orange-600 rounded-lg transition-colors shadow-sm"
                            >
                                <Check className="w-4 h-4" />
                                Alle akzeptieren
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CookieBanner;
